import React, { Fragment } from 'react';

import Terms from '../containers/SaasModern/PrivacyTerms/terms';

export default Terms;
